module.exports = __webpack_public_path__ + "static/img/logoHeader.b235701b.png";